import React from 'react';
import { X } from 'lucide-react';

const ImagePreviewModal = ({ isOpen, onClose, imageUrl, altText }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] overflow-y-auto">
      <div 
        className="fixed inset-0 bg-black bg-opacity-75 transition-opacity"
        onClick={onClose}
      />
      
      <div className="relative min-h-full flex items-center justify-center p-4">
        <div className="relative">
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-2 right-2 text-white bg-black bg-opacity-50 rounded-full p-1 hover:bg-opacity-75 z-10"
          >
            <X className="h-6 w-6" />
          </button>
          
          {/* Image */}
          <img 
            src={imageUrl} 
            alt={altText}
            className="max-h-[90vh] max-w-[90vw] object-contain rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default ImagePreviewModal;